<template>
    <div class="mb-4">
        <h3>{{ week.name }}</h3>
        <div class="row">
            <div v-for="day in week.days" v-bind:key="day.id" :class="dayColumnClass">
                <mealplan-day-component :initial-day="day" @day-updated="dayUpdated">
                </mealplan-day-component>
            </div>
        </div>
    </div>
</template>
<script>
  import { each } from "lodash";
  export default {
    props: [
        'initialWeek'
    ],
    data() {
        return {
            week: this.initialWeek,
        }
    },
    mounted() {
    },
    computed: {
        dayColumnClass: function() {
            var width = 12 / this.week.days.length
            return 'col-lg-' + width;
        },
    },
    methods: {
        dayUpdated: function(day) {
            var _this = this;
            // axios.get('/api/meal_plans/' + _this.mealPlanId).then(function (response) {
                // _this.mealPlan = response.data.data;
            _this.$emit('week-updated');
            // });
        },
    },
    watch: {
        initialWeek: function (newVal,oldVal) {
            Vue.set(this, 'week', newVal);
        }
    }
}
</script>
